import React from 'react';
import { RCIcon } from '../RCIcon';

interface IProps {
  svgComponent: (props: React.SVGProps<SVGElement>) => React.ReactSVGElement; // a specific svg imported from commons/design-system/icons
  children: React.ReactNode;
  placement?: 'right' | 'left',
}

function IconWithWrapper({ placement, svgComponent }) {
  return (
    <span className={placement === 'left' ? 'mr-space' : 'ml-space'}>
      <RCIcon svgComponent={svgComponent} inline />
    </span>
  );
}

export function RCTextWithIcon({ svgComponent, children, placement = 'right' }: IProps) {
  return (
    <>
      {(placement === 'left') && <IconWithWrapper placement={placement} svgComponent={svgComponent} />}
      {children}
      {(placement === 'right') && <IconWithWrapper placement={placement} svgComponent={svgComponent} />}
    </>
  );
}
